import CommonComponents from '@/components/templates/common'
import { useTemplateContext } from '@/context/TemplateProvider'

import Layout from './beauty-shop-slides.views'

const BeautyShopHeroWithSlides = () => {
  const { template } = useTemplateContext()
  
  return (
    <Layout className='select-none pointer-events-none'>
      <Layout.Header textColor="primary" backgroundColor="#ffffff">
        <CommonComponents.Wrapper>
          <Layout.Logo>
            {template.logo.src ? (
              <Layout.LogoImage src={template.logo.src} />
            ) : (
              <Layout.LogoText fontFamily={template.logo.fontFamily}>
                {template.logo.text}
              </Layout.LogoText>
            )}
          </Layout.Logo>
          <Layout.Navigation textColor="primary" hasShoppingCart={template.sections.navigation.hasShoppingCart} />
        </CommonComponents.Wrapper>
      </Layout.Header>

      <Layout.SubHeader>
        <Layout.SubHeaderTitle>{template.sections.header?.title}</Layout.SubHeaderTitle>
      </Layout.SubHeader>

      <Layout.Hero backgroundImage={template.sections.hero.backgroundImage} textColor="textSecondary">
        <Layout.HeroContainer>
          <CommonComponents.Wrapper>
            <Layout.TitleBox>
              <Layout.TitleContainer>
                <Layout.TitleDescription>{template.sections.hero.subtitle2}</Layout.TitleDescription>
                <Layout.Title>{template.sections.hero.title}</Layout.Title>
                <Layout.Subtitle>{template.sections.hero.subtitle}</Layout.Subtitle>
                
                {/* CTA Button with outlined variant and light text */}
                <Layout.CTA 
                  variant='outlined' 
                  type='secondary'           // Secondary border and background color
                  textColor='textSecondary'  // Light text (mapped to palette.text.secondary)
                >
                  {template.sections.hero.ctaText}
                </Layout.CTA>
              </Layout.TitleContainer>
            </Layout.TitleBox>
          </CommonComponents.Wrapper>
        </Layout.HeroContainer>
      </Layout.Hero>
    </Layout>
  )
}

export default BeautyShopHeroWithSlides
